import React from "react";
import { Eye, Droplets, Zap, Wrench } from "lucide-react";
import { TECHNOLOGY } from "../mock/data";
import useReveal from "../hooks/useReveal";

const ICONS = { Eye, Droplets, Zap, Wrench };

function TechCard({ item, i }) {
  const { ref, inView } = useReveal();
  const Icon = ICONS[item.icon] || Zap;
  return (
    <div
      ref={ref}
      style={{ animationDelay: `${i * 0.1}s` }}
      className={`reveal ${inView ? "in-view" : ""} group bg-[#111] border border-white/10 p-8 hover:bg-[#161616] hover:-translate-y-1 transition-all duration-300`}
    >
      <div className="w-14 h-14 flex items-center justify-center bg-baja-red/10 group-hover:bg-baja-red transition-colors duration-300 mb-6">
        <Icon className="baja-red group-hover:text-white transition-colors" size={26} />
      </div>
      <h3 className="font-display text-2xl uppercase text-white">{item.title}</h3>
      <p className="mt-3 text-white/55 leading-relaxed">{item.desc}</p>
    </div>
  );
}

export default function TechnologySection() {
  const { ref, inView } = useReveal();
  return (
    <section id="technology" className="relative bg-[#0a0a0a] py-24 overflow-hidden">
      {/* subtle red glow accent */}
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-baja-red/10 rounded-full blur-3xl pointer-events-none" />
      <div className="max-w-[1400px] mx-auto px-5 md:px-8 relative">
        <div ref={ref} className={`reveal ${inView ? "in-view" : ""} text-center max-w-3xl mx-auto`}>
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="h-[2px] w-10 bg-baja-red" />
            <span className="font-cond uppercase tracking-[0.25em] text-sm baja-red">The Science of Lighting</span>
            <span className="h-[2px] w-10 bg-baja-red" />
          </div>
          <h2 className="font-display text-4xl md:text-6xl uppercase leading-[0.95] text-white">
            RACE-BRED TECHNOLOGY
          </h2>
          <p className="mt-5 text-white/60 text-lg leading-relaxed">
            Every Baja Designs light is packed with patented technology, born from decades of desert racing where failure is not an option.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {TECHNOLOGY.map((t, i) => (
            <TechCard key={t.id} item={t} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
